import { createReducer } from "@reduxjs/toolkit";
import {
    InitialState,
} from "./types";
import { reducerHelper } from '../reducerHelper'
import {
    getTtnParameters,
    setTtn,
    comingNomenclatureReport,
    setInvoice,
    getInvoice,
    getReportPassport,
    setReportPassport
} from "./actions";

const initialState: InitialState = {
    getTtnParameter: {
        data: null,
        loading: false,
        error: null,
    },
    setTtn: {
        loading: false,
        error: null,
    },
    comingNomenclatureReport: {
        loading: false,
        error: null,
    },
    getInvoice: {
        data: null,
        loading: false,
        error: null,
    },
    setInvoice: {
        loading: false,
        error: null,
    },
    getReportPassport: {
        data: null,
        loading: false,
        error: null,
    },
    setReportPassport: {
        loading: false,
        error: null,
    }
}

export const reportReducer = createReducer(initialState, (builder) => {
    reducerHelper<InitialState>(builder, getTtnParameters, 'getTtnParameter', null);
    reducerHelper<InitialState>(builder, setTtn, 'setTtn', false);
    reducerHelper<InitialState>(builder, comingNomenclatureReport, 'comingNomenclatureReport', false);
    reducerHelper<InitialState>(builder, getInvoice, 'getInvoice', null);
    reducerHelper<InitialState>(builder, setInvoice, 'setInvoice', false);
    reducerHelper<InitialState>(builder, getReportPassport, 'getReportPassport', null);
    reducerHelper<InitialState>(builder, setReportPassport, 'setReportPassport', false);
})
